import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs) {
	return twMerge(clsx(inputs));
}

/** "2024.06 - PRESENT" 같은 문자열에서 연도만 뽑아 라벨로 */
export function yearOf(period = "") {
	const m = String(period).match(/\d{4}/);
	return m ? m[0] : "—";
}

/** 목록에서 기술 스택을 빈도순으로 집계 */
export function topTech(list = [], limit = 18) {
	const count = new Map();
	list.forEach((p) => (p.tech || []).forEach((t) => count.set(t, (count.get(t) || 0) + 1)));
	return [...count.entries()].sort((a, b) => b[1] - a[1]).slice(0, limit).map(([t]) => t);
}
